import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext(null);

export const InquiryProvider = ({ children }) => {
  const [order, setOrder] = useState({ open: false, product: "" });
  const [quote, setQuote] = useState({ open: false, product: "" });

  const openOrder = useCallback((product = "") => setOrder({ open: true, product }), []);
  const openQuote = useCallback((product = "") => setQuote({ open: true, product }), []);
  const closeOrder = useCallback(() => setOrder((o) => ({ ...o, open: false })), []);
  const closeQuote = useCallback(() => setQuote((q) => ({ ...q, open: false })), []);

  return (
    <Ctx.Provider value={{ order, quote, openOrder, closeOrder, openQuote, closeQuote }}>
      {children}
    </Ctx.Provider>
  );
};

export const useInquiry = () => useContext(Ctx);
